import Page from 'components/modules/public/pages/Home';
export default Page;